import { Link } from "react-router-dom";
import { Section } from "@/components/Section";

export default function NotFound() {
  return (
    <Section className="pt-32" testId="not-found-page">
      <div className="max-w-xl mx-auto text-center">
        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-600 mb-4">404</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter text-slate-900">
          That page doesn't exist.
        </h1>
        <p className="mt-4 text-slate-600">The link you followed may be broken or the page may have moved.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-1.5 bg-slate-900 text-white rounded-full px-6 py-3 text-sm font-semibold hover:bg-slate-800 transition-colors"
        >
          Back to home
        </Link>
      </div>
    </Section>
  );
}
